<!--
	用法:
        this.$store.commit('showLoading', true);展示
        this.$store.commit('showLoading', false);不展示

    <div class="main">
       <Loading v-show="isLoading" />
    </div>

    .main{
      position: relative;//必加
    }
 -->

<template>
  <div class="loading">
    <div class="loading-layer"></div>
    <span style="color: #c62e3f;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 101;
    margin-left: -75px;
    margin-top: 7px;">签署中，请勿离开此页...</span>
    <img src="../../assets/images/data-loading.gif">
  </div>
</template>

<script>
export default {};
</script>

<style>
.loading-layer {
  height: 100%;
  width: 100%;
}
.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 100;
  border-radius: 0 !important;
  background-color: rgba(0, 0, 0, 0) !important;
  padding: 0 !important;
}
.loading .loading-layer {
  background-color: rgba(0, 0, 0, 0.2);
}
.loading img {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 101;
}
</style>
